import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"

import tokens from "../_tokens"

// source: https://github.com/primer/components/blob/main/src/TextInput.js
// using sforwardRef is important so that other components (ex. SelectMenu) can autofocus the input
const TextInput = React.forwardRef(
  ({ className, disabled, width, ...props }, ref) => {
    return (
      <Wrapper className={className} disabled={disabled} width={width}>
        <Input ref={ref} disabled={disabled} {...props} />
      </Wrapper>
    )
  }
)

TextInput.displayName = "TextInput"

TextInput.propTypes = {
  width: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
}

const Input = styled.input`
  border: 0;
  font-family: inherit;
  -webkit-appearance: none;
  width: 100%;
  border-radius: 4px;
  font-size: ${tokens.fontSize.text.base};
  font-size: inherit;
  color: inherit;
  padding: 5px 10px;

  background: transparent;
  &:focus {
    outline: 0;
  }
`

const Wrapper = styled.span`
  display: inline-flex;
  align-items: stretch;
  width: ${props => props.width && props.width + "px"};
  min-height: 30px;
  /* border-radius: 4px; */
  outline: none;
  box-shadow: rgba(225, 228, 232, 0.2) 0px 2px 0px inset;
  box-sizing: border-box;
  border: solid 1px transparent;
  background-color: ${tokens.color.primaryTransparent};
  &:focus-within {
    border-color: ${tokens.color.primary};
  }
  ${props =>
    props.disabled &&
    css`
     background-color: rgba(255,255,255,0.07);
     box-shadow: none;
    }
  `}
  ${props =>
    props.block &&
    css`
      display: block;
      width: 100%;
    `}
`

export default TextInput
